import LOCAL_KEYS, { parseLocalStorageJSON } from "../../../helpers/Localstorage";
import { RequestBody } from "../../WebServiceManager/RequestBody";
import { RequestHeader } from "../../WebServiceManager/RequestHeader";
 

export default class empStatusRequestBody {

  documentsUploadRequest(obj, method) {
    const header = new RequestHeader();
    const request = new RequestBody(
      method,
      header.multiPartData(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
      obj
    );
    return request;
  }

    empStatusRequest(obj, method) {
      const header = new RequestHeader();
      const request = new RequestBody(
        method,
        header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
        obj
      );
      return request;
    }
 
    getEmpStatusRequest (obj, method) {
      const header = new RequestHeader();
      const request = new RequestBody(
        method,
        header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
        obj
      );
      return request;
    }

    getDocTypesRequest (method) {
      const header = new RequestHeader();
      const request = new RequestBody(
        method,
        header.applicationJson(parseLocalStorageJSON(LOCAL_KEYS.ACCESS_TOKEN)),
      );
      return request;
    }
}